import { StudentsSkillsProgress } from '@/types/progress';
import { SkillTypes } from '@/types/skill';
import { UserState } from '@/types/user';
import config from '@/config';

const UserUtils = {
  fromToLanguage: (user: UserState | null) => {
    const fromToLanguageParams = user?.metadata?.languagePreferences?.fromToLanguageParams || [];
    return fromToLanguageParams.length ? fromToLanguageParams[0] : 'pt-en';
  },
  getFirstName: (user: UserState | null) => {
    return user?.metadata?.firstName.split(' ')[0];
  },
  isTeacher: (user?: UserState | null) => {
    return user?.metadata?.role === 'teacher';
  },
  isAdmin: (user?: UserState | null) => {
    return user?.metadata?.role === 'admin';
  },
  isStudent: (user?: UserState | null) => {
    return user?.metadata?.role === 'student';
  },
  getDealExpiredDescriptionKey: (role?: string | null) => {
    switch ((role ?? '').toLowerCase()) {
      case 'admin':
        return 'registrationDealExpiredMessageDescriptionAdmin';
      case 'teacher':
        return 'registrationDealExpiredMessageDescriptionTeacher';
      default:
        return 'registrationDealExpiredMessageDescription';
    }
  },
  getCognitoUserPoolData: (_isClassCode: boolean | null = null) => {
    const userPoolKey = 'user_pool';

    if (config.isMGWebsite) {
      localStorage.setItem(userPoolKey, 'mg');
      return {
        awsCognitoDomain: config.mgAwsCognitoDomain,
        awsUserPoolId: config.mgAwsUserPoolId,
        awsCognitoClientId: config.mgAwsCognitoClientId,
      };
    }

    let isClassCode: boolean | null = _isClassCode;
    if (isClassCode === null) {
      isClassCode = localStorage.getItem(userPoolKey) === 'class_code';
    }

    if (isClassCode) {
      localStorage.setItem(userPoolKey, 'class_code');
      return {
        awsCognitoDomain: config.awsCognitoDomainUsername,
        awsUserPoolId: config.awsUserPoolIdUsername,
        awsCognitoClientId: config.awsCognitoClientIdUsername,
      };
    }

    localStorage.setItem(userPoolKey, 'ell');
    return {
      awsCognitoDomain: config.awsCognitoDomain,
      awsUserPoolId: config.awsUserPoolId2,
      awsCognitoClientId: config.awsCognitoClientId2,
    };
  },
  openGoogleLogin: () => {
    const cognitoUserPoolData = UserUtils.getCognitoUserPoolData();

    const loginParams = {
      domain: cognitoUserPoolData.awsCognitoDomain,
      clientId: cognitoUserPoolData.awsCognitoClientId,
      redirectUri: `${window.location.origin}/login`,
    };

    const googleLoginUrl = new URL(`https://${loginParams.domain}/oauth2/authorize`);
    googleLoginUrl.searchParams.append('response_type', 'code');
    googleLoginUrl.searchParams.append('client_id', loginParams.clientId);
    googleLoginUrl.searchParams.append('redirect_uri', loginParams.redirectUri);
    googleLoginUrl.searchParams.append('identity_provider', 'Google');
    googleLoginUrl.searchParams.append('access_type', 'offline');
    googleLoginUrl.searchParams.append('prompt', 'login select_account');

    window.location.href = googleLoginUrl.toString();
  },
  logoutGoogleUser: (reconnect: boolean = false) => {
    const cognitoUserPoolData = UserUtils.getCognitoUserPoolData();

    const logoutParams = {
      domain: cognitoUserPoolData.awsCognitoDomain,
      clientId: cognitoUserPoolData.awsCognitoClientId,
      redirectUri: `${window.location.origin}/login${reconnect ? '?reconnect=true' : ''}`,
    };

    const googleLogoutUrl = new URL(`https://${logoutParams.domain}/logout`);
    googleLogoutUrl.searchParams.append('client_id', logoutParams.clientId);
    googleLogoutUrl.searchParams.append('logout_uri', logoutParams.redirectUri);

    window.location.href = googleLogoutUrl.toString();
  },
};

export default UserUtils;
